import * as types from './types';

export const CONNECTED = 'connected';
export const DISCONNECTED = 'disconnected';

const initialState = {
  status: CONNECTED,
  disconnectedSince: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CONNECTED: {
      if (state.status === CONNECTED) return state;
      return {
        ...state,
        status: CONNECTED,
        disconnectedSince: null
      };
    }
    case types.DISCONNECTED: {
      const disconnectedSince = Math.min(state.disconnectedSince || Date.now(), Date.now());
      return {
        ...state,
        status: DISCONNECTED,
        disconnectedSince
      };
    }
    default: {
      return state;
    }
  }
};
